


































































































import { Mixins, Component, Watch } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class GameVersion extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Version',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Maintenance status',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Type',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Action',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage version',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  action = false;

  version = false;

  statusMaintenance = '';

  url = '';

  prefix = '';

  socketStatus = [];

  partnerList = [];

  partnerType = 'all';

  list: string[] = [];

  buttonAll = false;

  _id = '';

  isMaintenanceAll = false;

  @Watch('data')
  watchvalue(val) {
    this.socketStatus = val.filter((s: any) => [900, 901].includes(s.status));
  }

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchMaintenanceGame();
    if (res.code) {
      this.checkError(res);
    } else {
      this.data = res;
      this.list = [];
      res.forEach((v: any) => {
        this.list.push(v.prefix);
      });
    }
    this.GeneralInstance.toggleLoading(false);
  }

  editAction(val) {
    this.prefix = val.prefix;
    this.action = true;
  }

  editVersion(val) {
    this.prefix = val.prefix;
    this.url = val.url;
    this._id = val._id;
    this.version = true;
  }

  async handleMaintanence(val) {
    if (val === '0') {
      const res = await this.GameInstance
        .MaintenanceGames({ games: [this.prefix], maintenance: false });
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    } else {
      const res = await this.GameInstance
        .MaintenanceGames({ games: [this.prefix], maintenance: true });
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.action = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  async handleVersion(val) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.GameVersion({ url: val, _id: this._id });
    if (res.code === 0) {
      this.checkError(res);
    } else {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.version = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  async maintenanceAll() {
    this.GeneralInstance.toggleLoading(true);
    const statusGames = await this.data.filter((s: any) => [900, 901].includes(s.status));
    if (statusGames.length) {
      this.buttonAll = false;
      const res = await this.GameInstance
        .MaintenanceGames({ games: this.list, maintenance: false });
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    } else {
      this.buttonAll = true;
      const res = await this.GameInstance
        .MaintenanceGames({ games: this.list, maintenance: true });
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.GeneralInstance.toggleLoading(false);
    this.data = [];
    this.fetchGame();
  }
}
